import { connect } from 'react-redux';

import { bindActionCreators } from 'redux';

import GlobalSnackbar from '../../components/GlobalSnackbar';
import { Creators as AppCreators } from '../../redux/reducers/app';

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      feedbackRequest: AppCreators.feedbackRequest,
    },
    dispatch
  );

const mapStateToProps = ({ app }) => ({
  feedback: app.getIn(['feedback'], {}),
});

export default connect(mapStateToProps, mapDispatchToProps)(GlobalSnackbar);
